import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import {
    SAVE_STORE_CHANGED,
    APP_LEAVING,
    LOGIN_SET_THEME,
    LOGIN_SET_CONFIG,
    CALCULATE_FONT_USAGE
} from '../../constants/ActionTypes';

import CTModal from '../helpers/CTModal';

import { checkPermissions, httpClient } from '../../../lib/utils';
import { ThemeService } from '../../services/ThemeService';
import { ConfigurationService } from '../../services/ConfigurationService';

import { ACCESS_POINT_LEVEL, ACCESS_POINTS_GROUP } from '../../constants/AccessPoints';

import { SparkToggleSwitch } from '../ui/spark';
import { envValue } from '../../../config/envUtils';
import { postResponseToSplunkFailed } from '../../services/logging/splunklogging';
import { get } from 'lodash';

class ModalThemeAndConfig extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.onSave = this.onSave.bind(this);
        this.handleSelectPopertyLevelTheme = this.handleSelectPopertyLevelTheme.bind(this);
        this.handleSelectPopertyLevelConfig = this.handleSelectPopertyLevelConfig.bind(this);
        this.state = {
            selectedLevelTheme: 'Chain',
            selectedLevelConfig: 'Chain',
            levels: ['Chain', 'Brand', 'Hotel'],
            activeTab: 'hosted'
        };
        this.refSelectThemePopertyLevelElm = null;
        this.selectThemePopertyLevelElm = null;
        this.refSelectConfigPopertyLevelElm = null;
        this.selectConfigPopertyLevelElm = null;
    }

    componentDidMount() {
        this.selectPopertyThemeLevelElm = new SparkToggleSwitch(this.refSelectThemePopertyLevelElm);
        this.selectPopertyConfigLevelElm = new SparkToggleSwitch(this.refSelectConfigPopertyLevelElm);
    }

    onClose() {
        this.props.close();
    }

    onSave() {
        this.onClose();
    }

    handleSelectPopertyLevelTheme(e) {
        this.setState({ selectedLevelTheme: e.target.value });
    }

    handleSelectPopertyLevelConfig(e) {
        this.setState({ selectedLevelConfig: e.target.value });
    }

    handleOnSelectConfig = (elem) => {
        const { app } = this.props;
        this.props.toggleLoading(true);
        ConfigurationService.get(
            get(app, 'selected.chain.Id'),
            get(app, 'selected.selectedHotel.id'),
            get(elem, 'ContentCode'),
            get(app, 'selected.level')
        ).then(response => {
            const config = get(response, 'data.BEDesignerResult.Value.Data')
            const configCode = get(response, 'data.BEDesignerResult.ContentCode')

            try {
                this.props.setConfig(config, configCode);
            } catch (error) {
                postResponseToSplunkFailed(
                    get(response, 'config.method'),
                    get(response, 'config.url'),
                    moment().valueOf(),
                    get(error, 'message')
                );
            }
            this.props.toggleLoading(false);
        });
    }

    handleTabClick(tabName) {
        this.setState({ activeTab: tabName });
    }

    _renderThemeTable(themeList, defaultCode, currentThemeCode) {
        const filteredThemes = themeList
            .filter(element => element.level === this.props.selectedLevel)
            .filter(theme => {
                if (this.state.activeTab === 'hosted') {
                    return !theme.isSbemTheme;
                } else {
                    return theme.isSbemTheme;
                }
            });
        
        return (
            <table role="grid">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Date Modified</th>
                        <th>Status</th>
                        <th className="spark-text-center" />
                    </tr>
                </thead>
                <tbody>
                    {filteredThemes.map((elem, index) => {
                        const dateString = moment
                            .utc(elem.MetaData.Timestamp)
                            .format('MM/DD/YYYY');
                        const dateHour = moment
                            .utc(elem.MetaData.Timestamp)
                            .format('HH:mm');
                        return (
                            <tr key={index}>
                                <td>{elem.ContentCode}</td>
                                <td>
                                    <time style={{ marginRight: '10px' }}>
                                        {dateString}
                                    </time>
                                    <time>{dateHour}</time>
                                </td>
                                <td>
                                    {elem.ContentCode === defaultCode
                                        ? 'Default'
                                        : null}
                                </td>
                                <td className="spark-table__actions spark-text-center">
                                    {elem.ContentCode === currentThemeCode &&
                                    elem.level === this.props.selectedLevel &&
                                    elem.isSbemTheme === this.props.isThemeSbem ? (
                                            <button
                                                className="spark-btn spark-btn--sm"
                                                disabled
                                            >
                                            Selected
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    const SOURCEURL = envValue('SOURCEURL');
                                                    this.props.toggleLoading(true);
                                                    ThemeService.get(
                                                        this.props.app.selected.chain.Id,
                                                        this.props.app.selected
                                                            .selectedHotel.id,
                                                        elem.ContentCode,
                                                        this.props.app.selected.level,
                                                        elem.isSbemTheme ? 'SBEM' : 'SBE'
                                                    ).then(response => {
                                                        this.props.setTheme(
                                                            response.data.BEDesignerResult
                                                                .Value.Data,
                                                            response.data.BEDesignerResult
                                                                .ContentCode,
                                                            elem.isSbemTheme
                                                        );
                                                        this.props.toggleLoading(false);
                                                    });
                                                }}
                                                className="spark-btn spark-btn--sm"
                                            >
                                            Select
                                            </button>
                                        )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    _renderInContextTabs(themeList, defaultCode, currentThemeCode) {
        return (
            <div className='spark-margin-top'>
                <h4>Select Theme (styles)</h4>

                <div ref={node => (this.tabsNode = node)} className="spark-tabs col-lg-12">
                    <nav className="spark-tabs__nav" role="menubar">
                        <div className="spark-tabs__scroll">
                            <ul className="spark-tabs__list" role="tablist">
                                <li
                                    className={`spark-tabs__tab text-center ${this.state.activeTab === 'hosted' ? 'active' : ''}`}
                                    role="tab"
                                    aria-controls="hosted-tab"
                                    onClick={() => this.handleTabClick('hosted')}
                                >
                                    <a>Hosted</a>
                                </li>
                                <li
                                    className={`spark-tabs__tab text-center ${this.state.activeTab === 'incontext' ? 'active' : ''}`}
                                    role="tab"
                                    aria-controls="incontext-tab"
                                    onClick={() => this.handleTabClick('incontext')}
                                >
                                    <a>In-context</a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                
                    <div className="spark-table spark-tabs__panels">
                        <div 
                            role="tabpanel" 
                            className={`spark-tabs__panel ${this.state.activeTab === 'hosted' ? 'active' : ''}`}
                            id="hosted-tab"
                            style={{ display: this.state.activeTab === 'hosted' ? 'block' : 'none' }}
                        >
                            <div className="spark-panel__contents">
                                {this._renderThemeTable(themeList, defaultCode, currentThemeCode)}
                            </div>
                        </div>
                        
                        <div
                            role="tabpanel" 
                            className={`spark-tabs__panel ${this.state.activeTab === 'incontext' ? 'active' : ''}`}
                            id="incontext-tab"
                            style={{ display: this.state.activeTab === 'incontext' ? 'block' : 'none' }}
                        >
                            <div className="spark-panel__contents">
                                {this._renderThemeTable(themeList, defaultCode, currentThemeCode)}
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        );
    }

    _renderHostedTabs(themeList, defaultCode, currentThemeCode) {
        return (
            <div>
                <h4>Select Theme (styles)</h4>
                <div className="spark-table">
                    <div className="spark-table__scroll">
                        {this._renderThemeTable(themeList, defaultCode, currentThemeCode)}
                    </div>
                </div>
                <hr />
            </div>
        );
    }

    render() {
        const getLevelsForTheme = this.state.levels.map((level, i) => {
            const defaultChecked = level === this.state.selectedLevelTheme;
            return (
                <label className="col-xs-4 col-sm-2 spark-toggle" key={`selectPopertyLevel_${i}`}>
                    <input
                        name="chain-brand-hotel-level-theme"
                        defaultChecked={defaultChecked}
                        value={level}
                        onChange={this.handleSelectPopertyLevelTheme}
                        className="spark-toggle__input"
                        type="radio"
                    />
                    <span className="spark-label">{level}</span>
                </label>
            );
        });
        const defaultCode = this.props.app.selected.defaultContentCode;
        const defaultConfigCode = this.props.app.selected.defaultContentConfigCode;
        const currentConfigCode = this.props.app.data.configuration.configuration.configCode;
        const currentThemeCode = this.props.app.selected.code;
        const themeList = this.props.app.selected.themeList || [];
        const configList = this.props.app.selected.configList || [];
        const getLevelsForConfig = this.state.levels.map((level, i) => {
            const defaultChecked = level === this.state.selectedLevelConfig;
            return (
                <label className="col-xs-4 col-sm-2 spark-toggle" key={`selectPopertyLevel_${i}`}>
                    <input
                        name="chain-brand-hotel-level-config"
                        defaultChecked={defaultChecked}
                        value={level}
                        onChange={this.handleSelectPopertyLevelConfig}
                        className="spark-toggle__input"
                        type="radio"
                    />
                    <span className="spark-label">{level}</span>
                </label>
            );
        });

        return (
            <CTModal
                open={this.props.open}
                primaryButton={true}
                primaryButtonTitle="Close"
                primaryButtonClick="close"
                onAfterClose={this.props.close}
                secondaryButton={false}
                secondaryButtonClick="close"
                secondaryButtonTitle="Cancel"
            >
                <div>
                    <div>
                        <div
                            ref={node => (this.refSelectThemePopertyLevelElm = node)}
                            className="row spark-toggle-group spark-margin-top"
                        />
                        {(this.props.permissionTheme.view || this.props.permissionTheme.edit) && (
                            this.props.inContextBeta
                            ? this._renderInContextTabs(themeList, defaultCode, currentThemeCode)
                            : this._renderHostedTabs(themeList, defaultCode, currentThemeCode)
                        )}
                    </div>

                    <div>
                        <div
                            ref={node => (this.refSelectConfigPopertyLevelElm = node)}
                            className="row spark-toggle-group spark-margin-top"
                        />
                        {(this.props.permissionSettings.view ||
                            this.props.permissionSettings.edit ||
                            this.props.permissionTrackingHooks.view ||
                            this.props.permissionTrackingHooks.edit) && (
                            <div>
                                <h4>Select configuration (settings)</h4>
                                <div className="spark-table">
                                    <div className="spark-table__scroll">
                                        <table role="grid">
                                            <thead>
                                                <tr>
                                                    <th>Code</th>
                                                    <th>Date Modified</th>
                                                    <th>Status</th>
                                                    <th className="spark-text-center" />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {configList
                                                    .filter(element => {
                                                        return element.level === this.props.selectedLevel;
                                                    })
                                                    .map((elem, index) => {
                                                        const dateString = moment
                                                            .utc(elem.MetaData.Timestamp)
                                                            .format('MM/DD/YYYY');
                                                        const dateHour = moment
                                                            .utc(elem.MetaData.Timestamp)
                                                            .format('HH:mm');
                                                        return (
                                                            <tr key={index}>
                                                                <td>{elem.ContentCode}</td>
                                                                <td>
                                                                    <time style={{ marginRight: '10px' }}>
                                                                        {dateString}
                                                                    </time>
                                                                    <time>{dateHour}</time>
                                                                </td>
                                                                <td>
                                                                    {elem.ContentCode === defaultConfigCode
                                                                        ? 'Default'
                                                                        : null}
                                                                </td>
                                                                <td className="spark-table__actions spark-text-center">
                                                                    {elem.ContentCode === currentConfigCode &&
                                                                    elem.level === this.props.selectedLevel ? (
                                                                            <button
                                                                                className="spark-btn spark-btn--sm"
                                                                                disabled
                                                                            >
                                                                            Selected
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                onClick={() => this.handleOnSelectConfig(elem)}
                                                                                className="spark-btn spark-btn--sm"
                                                                            >
                                                                            Select
                                                                            </button>
                                                                        )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </CTModal>
        );
    }
}

ModalThemeAndConfig.defaultProps = {
    open: false
};

ModalThemeAndConfig.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
};

/**
 STORE stuff. See store/AppStore.js
*/

export const SHOW_MODAL_THEME_AND_CONFIG = 'SHOW_MODAL_THEME_AND_CONFIG';
export const HIDE_MODAL_THEME_AND_CONFIG = 'HIDE_MODAL_THEME_AND_CONFIG';

const initialState = {
    isOpened: false
};

export const modalThemeAndConfigReducer = (state = initialState, action) => {
    switch (action.type) {
    case SHOW_MODAL_THEME_AND_CONFIG:
        return {
            isOpened: true
        };
    case HIDE_MODAL_THEME_AND_CONFIG:
    case APP_LEAVING:
        return {
            isOpened: false
        };
    default:
        return state;
    }
};

export const modalThemeAndConfigActions = {
    show() {
        return dispatch => {
            dispatch({ type: SHOW_MODAL_THEME_AND_CONFIG });
        };
    },
    hide() {
        return dispatch => {
            dispatch({ type: HIDE_MODAL_THEME_AND_CONFIG });
        };
    }
};

/**
 /STORE stuff. See store/AppStore.js
*/

const mapStateToProps = state => {
    return {
        open: state.app.modal.themeAndConfig.isOpened,
        app: state.app,
        code: state.app.data.configuration.configuration.configCode,
        inContextBeta: get(state, 'app.selected.inContextBeta', false),
        selectedLevel: state.app.selected.level,
        isThemeSbem: state.app.selected.isThemeSbem,
        permissionTheme: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        permissionSettings: checkPermissions(state, ACCESS_POINTS_GROUP.CONFIGURATION),
        permissionTrackingHooks: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS)
    };
};

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(modalThemeAndConfigActions.hide()),
    setTheme: (theme, code, isSbemTheme = false) => {
        dispatch({ type: LOGIN_SET_THEME, theme, code, isSbemTheme });
        dispatch({ type: CALCULATE_FONT_USAGE });
    },
    setConfig: (theme, code) => {
        dispatch({ type: LOGIN_SET_CONFIG, config: theme, code });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalThemeAndConfig);



// WEBPACK FOOTER //
// ./src/components/modals/ModalThemeAndConfig.js